export default __webpack_public_path__ + "static/media/external-link.755f2da6.svg";